<template>
 <div>
   <div v-if="hasVideo" class="embed-responsive embed-responsive-16by9">
     <entity-video-wrapper :entity="entity" class="embed-responsive-item videoWrapper"></entity-video-wrapper>
   </div>
   <div v-else-if="hasThumb" class="">
     <entity-thumb-wrapper :entity="entity"></entity-thumb-wrapper>
   </div>
   <div v-else class="text-center pt-4 no-media">
     No Preview
   </div>
 </div>
</template>

<script>

import { entityHasThumbDerivs, entityHasVideoDerivs } from '#/models/entities/entity';
import EntityVideoWrapper from '#/ui/Components/Entities/EntityVideoWrapper.vue';
import EntityThumbWrapper from '#/ui/Components/Entities/EntityThumbWrapper.vue';

export default {
  components: {
    EntityThumbWrapper,
    EntityVideoWrapper,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    name() {
      // properly make sure this stays as one row. and doesn't trigger overflow into a second row
      let name = this.entity.name ? this.entity.name : '(No Name)';
      if (name.length > 15) {
        name = `${name.substring(0, 15)}...`;
      }
      return name;
    },
    hasThumb() {
      return entityHasThumbDerivs(this.entity);
    },
    hasVideo() {
      return entityHasVideoDerivs(this.entity);
    },
  },
  methods: {
    openFile() {
      const path = `/files/${this.entity.size}/${this.entity.checksum}`;
      console.info('opening file:', path);
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>

</style>
